import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useImperativeHandle } from "react";
import { Form } from "antd";
import SenderReceiverSelect from "./SenderReceiverSelect";
const SenderReceiverSelectForm = (props, exportedRef) => {
    const [form] = Form.useForm();
    useImperativeHandle(exportedRef, () => ({
        submit,
        resetFields,
        validateFields
    }));
    useEffect(() => {
        if (props.senderReceiverId) {
            form.setFieldsValue({
                selectedId: props.senderReceiverId
            });
        }
    }, [props.senderReceiverId]);
    const validateFields = () => {
        return form.validateFields();
    };
    const resetFields = () => {
        return form.resetFields();
    };
    const submit = () => {
        return form.submit();
    };
    const onFinish = (formValues) => {
        props.onFinish(formValues.senderReceiverId);
    };
    return (_jsx(Form, { layout: "vertical", form: form, onFinish: onFinish, children: _jsx(Form.Item, { name: "selectedId", label: "Saved Location", valuePropName: "senderReceiverId", initialValue: props.senderReceiverId, rules: [{
                    required: props.required,
                    message: 'Please select a saved location',
                }], children: _jsx(SenderReceiverSelect, { allowClear: props.allowClear, disabled: props.disabled, tenantId: props.tenantId, onChange: props.onChange, onSenderReceiverSelected: props.onSenderReceiverSelected, senderReceiverId: props.senderReceiverId }) }) }));
};
export default React.forwardRef(SenderReceiverSelectForm);
